var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ABABAB",
    fillRule: "evenodd",
    d: "M8 10.666a.662.662 0 0 1-.427-.154l-4-3.334a.666.666 0 1 1 .853-1.024l3.58 2.984 3.576-2.876a.667.667 0 0 1 .836 1.038l-4 3.219a.667.667 0 0 1-.418.147",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 10,
    height: 5,
    x: 3,
    y: 6,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8 10.666a.662.662 0 0 1-.427-.154l-4-3.334a.666.666 0 1 1 .853-1.024l3.58 2.984 3.576-2.876a.667.667 0 0 1 .836 1.038l-4 3.219a.667.667 0 0 1-.418.147",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ABABAB",
    d: "M0 0h16v16H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownSmallIcon);
export default __webpack_public_path__ + "static/media/ArrowDownSmallIcon.8af2fddf9c76d882af4e831f4777818c.svg";
export { ForwardRef as ReactComponent };